import React from 'react';

// === Components ===  //
import ListWithIconsItem from '@components/sections/components/ListWithIconsItem';
import Container from '@components/common/Container';

// === Styles === //
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { breakpoints, colors, respondTo } from '@styles';
import { Variant } from '@content/types/layout';

const List = styled.ul`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 20px 0;
  flex-wrap: wrap;
  ${respondTo(
    breakpoints.md,
    css`
      justify-content: center;
    `
  )}

  &.six-box {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 0;
    flex-wrap: wrap;
    ${respondTo(
      980,
      css`
        justify-content: center;
      `
    )}
  }
`;

const ListWithIconWrapper = styled.div<ListItemVariants>`
  background: ${(props) =>
    props.background === true
      ? props.variant === 'blue'
        ? colors.ui.patientDefault
        : colors.ui.hcpDefault
      : 'transparent'};
`;

interface ListItemIconProps {
  data: ListItemData[];
  variant: Variant;
  background?: boolean;
}

interface ListItemVariants {
  background: boolean;
  variant: Variant;
}

interface ListItemData {
  icon: string;
  text: string;
  alt?: string;
  title?: string;
}

const ListWithIcon = ({ data, background = false, variant }: ListItemIconProps) => {
  const listLength = data.length;

  return (
    <ListWithIconWrapper variant={variant} background={background}>
      <Container>
        <List className={listLength > 4 ? 'six-box' : ''}>
          {data.map((item, index) => {
            return (
              <ListWithIconsItem
                background={background}
                className={listLength > 4 ? 'six-box' : ''}
                icon={item.icon}
                alt={item.alt}
                title={item.title}
                text={item.text}
                key={index}
              />
            );
          })}
        </List>
      </Container>
    </ListWithIconWrapper>
  );
};

export default ListWithIcon;
